import { render, staticRenderFns } from "./UcRegisterSelector.yaml?vue&type=template&id=fdc8f3b0&component"
import script from "./UcRegisterSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegisterSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports